module.exports = __webpack_public_path__ + "app/components/devices/devices.view.html";